import React, { Component } from "react";
import { inject, observer } from 'mobx-react';
import { Modal } from 'react-bootstrap'

// elements
import Button from '~/components/CustomButton/CustomButton.jsx';
import LoadingSpinner from '~/elements/LoadingSpinner';

// components
import withLocalization from "../../../hoc/withLocalization";

// utils
import { shortDateFormat } from '~/utils/dateFormat';

//assets
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import SwitchWidget from "../ControlPanel/SwitchWidget";
import { ProjectsWidget } from "../../../components/GenericForm/Widgets/ProjectsWidget";
import { TasksWidget } from "../../../components/GenericForm/Widgets/TasksWidget";

class PublishTemplateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            templateList: [],
            expandedTemplates: {},
            assigningRows: {},
            rowSelections: {},
            page: 1,
            limit: 10,
            total: 0,
        };
        this.scheduleRef = React.createRef();
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = async (page = 1) => {
        const { rosterStore, userStore } = this.props;
        const { limit } = this.state;
        let pmMembers = '';
        if (userStore?.currentUser.user_type !== 'admin' && userStore?.currentUser?.Manages?.length) {
            pmMembers = userStore?.currentUser.Manages.join(',');
        }
        this.setState({ isLoading: true });
        const res = await rosterStore.getActiveRosters({ pmMembers, page, limit });
        const templateList = res?.rosterTemplates || [];
        const total = res?.total || 0;
        const expandedTemplates = {};
        templateList.forEach(template => {
            if (!template.isBeforeLockIn) {
                expandedTemplates[template.id] = true;
            }
        });
        this.setState({ templateList, expandedTemplates, isLoading: false, page, total });
    }

    handlePageChange = (newPage) => {
        this.loadData(newPage);
    }

    handleClosePublishModal = (res) => {
        if (res?.isPublished === true) {
            this.props.commonStore.addNotification(res.message, null, 'success');
            this.props.close(true);
        }
    }

    toggleAssign = (templateId) => {
        this.setState(prev => {
            const turningOff = !!prev.expandedTemplates[templateId];
            if (!turningOff) {
                return {
                    expandedTemplates: { ...prev.expandedTemplates, [templateId]: true }
                };
            }
            const template = prev.templateList.find(t => t.id === templateId);
            const erIds = template ? template.employee_rosters.map(er => er.id) : [];

            const assigningRows = { ...prev.assigningRows };
            const rowSelections = { ...prev.rowSelections };
            erIds.forEach(id => {
                delete assigningRows[id];
                delete rowSelections[id];
            });

            return {
                expandedTemplates: { ...prev.expandedTemplates, [templateId]: false },
                assigningRows,
                rowSelections,
            };
        });
    }

    toggleAssignRow = (erId) => {
        this.setState(prev => {
            const isCurrentlyOpen = !!prev.assigningRows[erId];
            return {
                assigningRows: isCurrentlyOpen ? {} : { [erId]: true }
            };
        });
    }

    handleClearRow = (erId) => {
        this.setState(prev => {
            const rowSelections = { ...prev.rowSelections };
            delete rowSelections[erId];
            return { rowSelections };
        });
    }

    handleRowChange = (erId, field, value, option) => {
        const labelField = field === 'project_id' ? 'project_label' : field === 'task_id' ? 'task_label' : null;
        this.setState(prev => ({
            rowSelections: {
                ...prev.rowSelections,
                [erId]: {
                    ...(prev.rowSelections[erId] || {}),
                    [field]: value,
                    ...(labelField ? { [labelField]: option?.label || null } : {}),
                }
            }
        }));
    }

    getAssignPayload = () => {
        const { rowSelections } = this.state;
        return Object.entries(rowSelections)
            .filter(([, sel]) => sel.project_id || sel.task_id)
            .map(([erId, sel]) => ({
                employee_roster_id: Number(erId),
                project_id: sel.project_id || null,
                task_id: sel.task_id || null,
            }));
    }

    handleProceed = async () => {
        const { expandedTemplates } = this.state;
        const { rosterStore, commonStore, t } = this.props;

        const templateIds = Object.entries(expandedTemplates)
            .filter(([, val]) => val)
            .map(([id]) => Number(id));

        if (templateIds.length === 0) {
            commonStore.addNotification(t('Please select at least one template to publish'), null, 'warning');
            return;
        }

        const assignments = this.getAssignPayload();
        const res = await rosterStore.publishRoster({ templateIds, assignments });

        if (res.isPublished) {
            this.handleClosePublishModal(res);
        } else if (res.isAlreadyPublished === true) {
            commonStore.addNotification(res.message, null, 'error');
            this.props.close();
        }
    }

    render() {
        const { show, t, close, userStore, commonStore } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        const { isLoading, templateList, expandedTemplates, assigningRows, rowSelections, page, limit, total } = this.state;
        const totalPages = Math.ceil(total / limit);
        return (
            <Modal
                size="lg"
                centered
                show={show}
                onHide={() => close()}
            >
                <Modal.Header className="set_ModalHeader">
                    <Modal.Title className='w-100 text-center custom-modal-title'>
                        {t('Publish')} {t('Roster')}
                    </Modal.Title>
                    <img
                        src={CloseModalIcon}
                        className="cursor-pointer"
                        onClick={() => close()}
                        alt='close-btn'
                    />
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '60vh', minHeight: '50vh', overflowY: 'auto' }}>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : templateList.length === 0 ? (
                        <p className="text-center text-muted mt-3">{t('No active roster templates found')}</p>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            {templateList.map(template => (
                                <div key={template.id} style={{ borderRadius: 10, border: '1px solid #dee2e6' }}>
                                    <div
                                        className='d-flex justify-content-between align-items-center'
                                        style={{
                                            background: '#6a8ace',
                                            color: '#ffffff',
                                            padding: '4px 14px',
                                            borderRadius: 10
                                        }}
                                    >
                                        <div>
                                            <span className="fw-600 fs14">
                                                {template.name} <span className="fs12">({shortDateFormat(template.cycle_start_date, dateTimeRules)} - {shortDateFormat(template.cycle_end_date, dateTimeRules)})</span>
                                            </span>
                                            {template.isBeforeLockIn && (
                                                <div className="fw-600 mt-1 fs12 text-warning">
                                                    {t('This template starts before the lock-in date')} ({shortDateFormat(template.lockInDate, dateTimeRules)}) {t('Publishing will proceed if toggled on.')}
                                                </div>
                                            )}
                                            {template.templateWithExceptions && (
                                                <div className="fw-600 mt-1 fs12 text-danger-with-bg">
                                                    {t('This roster plan contains exceptions. Please review the assigned shifts before publishing.')}
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <SwitchWidget className='mt-2 mx-2'
                                                value={!!expandedTemplates[template.id]}
                                                onChange={checked => this.toggleAssign(template.id, checked)}
                                            />
                                            <label>
                                                {t('Publish')}
                                            </label>
                                        </div>
                                    </div>
                                    {template.employee_rosters.length === 0 ? (
                                        <div style={{ padding: '8px 14px', color: '#6c757d', fontSize: 13 }}>
                                            {t('No employees assigned')}
                                        </div>
                                    ) : (
                                        template.employee_rosters.map((er, idx) => {
                                            const isAssigning = !!assigningRows[er.id];
                                            const selection = rowSelections[er.id] || {};
                                            return (
                                                <div key={er.id} style={{
                                                    padding: '7px 14px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                    gap: 8,
                                                    fontSize: 13,
                                                    borderTop: '1px solid #f0f0f0',
                                                    background: idx % 2 === 0 ? '#f8f9fa' : '#fff'
                                                }}>
                                                    <span className="fw-600" style={{ minWidth: 120 }}>{er.name || ''}</span>

                                                    {isAssigning ? (
                                                        <>
                                                            <div style={{ flex: 1, minWidth: 160 }}>
                                                                <ProjectsWidget
                                                                    value={selection.project_id || null}
                                                                    onChange={(v, opt) => this.handleRowChange(er.id, 'project_id', v, opt)}
                                                                    applyOnFirstLoad
                                                                    filterByUser={er.user_id}
                                                                    fromShift={userStore.currentUser.user_type === 'pm'}
                                                                    menuPlacement="auto"
                                                                    maxMenuHeight={150}
                                                                />
                                                            </div>
                                                            <div style={{ flex: 1, minWidth: 160 }}>
                                                                <TasksWidget
                                                                    className="form-control"
                                                                    onChange={(value, opt) => this.handleRowChange(er.id, 'task_id', value, opt)}
                                                                    value={selection.task_id || null}
                                                                    defaultIfOne
                                                                    defaultByGeneric
                                                                    filterByUser={er.user_id}
                                                                    filterByProject={selection.project_id}
                                                                    menuPlacement="auto"
                                                                    maxMenuHeight={150}
                                                                />
                                                            </div>
                                                            <span
                                                                role="button"
                                                                className="projectassignbtn m-1"
                                                                onClick={() => this.toggleAssignRow(er.id)}
                                                            >
                                                                {t('Done')}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        expandedTemplates[template.id] && (
                                                            <div className="d-flex align-items-center flex-wrap" style={{ gap: 6 }}>
                                                                {(selection.project_id || selection.task_id) && (
                                                                    <span style={{ fontSize: 12, color: '#495057' }}>
                                                                        {selection.project_label && (
                                                                            <span className="fw-600">{selection.project_label}</span>
                                                                        )}
                                                                        {selection.project_label && selection.task_label && (
                                                                            <span className="mx-1">·</span>
                                                                        )}
                                                                        {selection.task_label && (
                                                                            <span>{selection.task_label}</span>
                                                                        )}
                                                                    </span>
                                                                )}
                                                                <span
                                                                    role="button"
                                                                    className="projectassignbtn m-1"
                                                                    onClick={() => this.toggleAssignRow(er.id)}
                                                                >
                                                                    {selection.project_id || selection.task_id
                                                                        ? t('Edit')
                                                                        : `${t('Publish')} ${t('Schedule Shifts')}`
                                                                    }
                                                                </span>
                                                                {(selection.project_id || selection.task_id) && (
                                                                    <span
                                                                        role="button"
                                                                        className="projectassignbtn m-1"
                                                                        onClick={() => this.handleClearRow(er.id)}
                                                                    >
                                                                        {t('Clear')}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-center align-items-center mt-3 mb-2" style={{ gap: 8 }}>
                            <Button
                                wd
                                disabled={page <= 1}
                                onClick={() => this.handlePageChange(page - 1)}
                            >
                                <i class="fa fa-arrow-left me-1" aria-hidden="true"></i>
                                {t('Prev')}
                            </Button>
                            <span className="fs14 fw-600">
                                {t('Pg.')} {page} / {totalPages}
                            </span>
                            <Button
                                fill wd
                                disabled={page >= totalPages}
                                onClick={() => this.handlePageChange(page + 1)}
                            >

                                {t('Next')}
                                <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                            </Button>
                        </div>
                    )}

                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-end gap-2">
                    <Button fill md onClick={this.handleProceed}>{t('Proceed')}</Button>
                    <Button onClick={() => close()}>{t('Close')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default inject('commonStore', 'userStore', 'rosterStore')(withLocalization(observer(PublishTemplateModal)));
